<template>
  <div>
    <div class="d-flex justify-end flex-wrap mt-n3">
      <v-btn
        v-for="action in availableActions"
        :key="action.action"
        :color="action.color || 'primary'"
        :disabled="action.fileRequired && !selectedFiles.length"
        class="action-button mb-4"
        :outlined="action.outlined"
        :style="`order: ${action.order}`"
        @click="makeAction(action)"
      >
        {{ allFilesSelected && action.allFilesLabel? action.allFilesLabel : action.label }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

const actionsConfig = {
  accept: {
    allFilesLabel: 'Zaakceptuj wszystkie',
    order: 5,
  },
  dismiss: {
    label: 'Odrzuć',
    color: 'error',
    order: 1,
  },
  send_to_verification: {
    label: 'Weryfikacja', outlined: true, order: 2,
  },
  request_changes: {
    label: 'Zmiana', outlined: true, order: 3,
  },
  archive: {
    label: 'Archiwizuj', outlined: true, order: 4,
  },
};

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
    selectedFiles: {
      type: Array,
      required: true,
    },
  },
  computed: {
    availableActions() {
      return this.project.actionsAvailable.map((action) => ({
          ...actionsConfig[action.name],
          ...action,
      }));
    },
    allFilesSelected() {
      return this.selectedFiles.length === this.project.files.length && !!this.project.files.length;
    },
  },
  methods: {
    ...mapActions('dialog', [
      'showDialog',
    ]),
    ...mapActions('snackbar', [
      'showSnackbar',
    ]),
    ...mapActions('project', [
      'makeProjectAction',
    ]),
    ...mapActions('quickAcceptance', [
      'fetchProjects',
    ]),
    makeAction(action) {
      if (action.name === 'archive') {
        this.makeProjectAction({
          actionName: action.name,
          fileIds: this.selectedFiles,
          projectId: this.project.id,
        })
          .then(() => {
            this.fetchProjects();
            this.showSnackbar({
              message: ['Zarchiwizowano'],
              type: 'success',
            });
          });
      } else {
        this.showDialog({
          header: 'Potwierdzenie działania',
          text: 'Potwierdź wykonanie akcji.',
          component: 'MakeAction',
          props: {
            id: this.project.id,
            actions: [action],
            files: this.project.files,
            width:640,
            specificData: {
              project: this.project,
              action,
              fileIds: this.selectedFiles,
            },
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.action-button {
  margin-left: 16px;
  height: 36px !important;
  width:208px;
  border-radius: 4px;
  font-size: 13px;
  &::v-deep > span {
    white-space: pre-wrap;
    max-width: 100%;
    line-height: 16px;
  }
}
</style>
